// extracted by mini-css-extract-plugin
export default {"fitAssistantButton":"eJWsf","iconContainer":"agHJy","icon":"wA8_Q"};